export function getContrast(hexColor, colorOverride) {
  if (hexColor.slice(0, 1) === "#") {
    hexColor = hexColor.slice(1);
  }

  let r = parseInt(hexColor.substr(0, 2), 16);
  let g = parseInt(hexColor.substr(2, 2), 16);
  let b = parseInt(hexColor.substr(4, 2), 16);
  let check = (r * 299 + g * 587 + b * 114) / 1000;

  if (colorOverride) {
    return colorOverride;
  }

  return check >= 128 ? "black" : "white";
}
